import { Component, input } from '@angular/core';

@Component({
  selector: 'onyx-logo',
  imports: [],
  templateUrl: './onyx-logo.component.html',
  styleUrl: './onyx-logo.component.scss',
})
export class OnyxLogoComponent {
  public readonly variant = input.required<
    'horizontal' | 'vertical' | 'signet'
  >();
  public readonly theme = input.required<'light' | 'dark'>();
}
